import type {
  Facility,
  FacilityGroupID,
  FacilityID,
  SimpleSelectable,
  TenantID,
  UserID,
} from '../../cross-app-shared/types/db.ts';
import { timestamp } from './dates.ts';

export function facilityCreateBlank(
  tenantID: TenantID,
  facilityGroupID: FacilityGroupID,
  userID: UserID,
): SimpleSelectable<Facility> {
  return {
    tenantID,
    facilityID: -1 as FacilityID,
    name: '',
    properName: '',
    triID: '',
    facilityGroupID,
    dunBradstreetCodes: [],
    npdesPermitNumbers: [],
    rcraIdNumbers: [],
    uicIdNumbers: [],
    naicsCodes: [],
    parentCompanyName: '',
    parentCompanyDunBradstreetCode: '',
    foreignParentCompanyName: '',
    foreignParentCompanyDunBradstreetCode: '',
    address: '',
    city: '',
    county: '',
    state: '',
    zip: '',
    mailingAddress: '',
    mailingCity: '',
    mailingState: '',
    mailingZip: '',
    certifierName: '',
    certifierTitle: '',
    publicContactName: '',
    publicContactEmail: '',
    publicContactPhone: '',
    publicContactPhoneExt: '',
    technicalContactName: '',
    technicalContactEmail: '',
    technicalContactPhone: '',
    technicalContactPhoneExt: '',
    createdBy: userID,
    createdAt: timestamp(),
    updatedBy: userID,
    updatedAt: timestamp(),
    deletedBy: null,
    deletedAt: null,
    // Assigned by the database on insert; a facility that has never been saved has none.
    tierIIExportIdentity: '',
  };
}
